import { Pipe, PipeTransform } from '@angular/core';

declare var moment: any;

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {

  transform(records: Array<any>, args?: any): any {
    return records.sort(function (a, b) {
      let aValue = a[args.property];
      let bValue = b[args.property];
      let aValueMoment = moment(a[args.property]);
      let bValueMoment = moment(b[args.property]);
      if (aValueMoment.isValid() && !bValueMoment.isValid())
        return 1 * args.direction;
      if (!aValueMoment.isValid() && bValueMoment.isValid())
        return -1 * args.direction;
      if (aValueMoment.isValid() && bValueMoment.isValid()) {
        if (aValueMoment.valueOf() < bValueMoment.valueOf())
          return -1 * args.direction;
        else if (aValueMoment.valueOf() > bValueMoment.valueOf())
          return 1 * args.direction;
        else
          return 0;
      }
      if (aValue && !bValue)
        return 1 * args.direction;
      if (!aValue && bValue)
        return -1 * args.direction;
      if (aValue < bValue)
        return -1 * args.direction;
      else if (aValue > bValue)
        return 1 * args.direction;
      else
        return 0;
    });
  };
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/orderby.pipe.ts